<template>
  <div>
    <titulo-btns :title="$t('PESSOAS.CONTATO') + '*'" class="mt-4 ajuste-titulo" >
      <b-button 
        variant="primary" 
        @click="criar" 
        v-if="!visualizar">
        {{ $t('PESSOAS.NOVO_CONTATO') }}
      </b-button>
    </titulo-btns>
    <div class="ajuste-check">
      <input-checkbox
        v-model="form.mesmoContatoResponsavelFinanceiro"
        :label="$t('PESSOAS.CONTATO_MESMO_CONTATO')"       
      />
    </div>
  </div>
</template>
<script>
import TituloBtns from '@/components/headers/TituloBtns.vue';
import InputCheckbox from '@/components/inputs/InputCheckbox.vue';

export default {
  components: { TituloBtns, InputCheckbox },
  props: {
    visualizar: { type: Boolean, default: false },
    form: { type: Object, default: () => {} }
  },
  methods: {
    criar() {
      this.$emit('criar');
    },
  },
};
</script>
<style scoped>
.ajuste-titulo {
  margin-bottom: 0px !important; 
}
.ajuste-check{
  margin-bottom: 20px;
}
</style>